import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const Header = styled.div`
  padding: ${({ padding }) => padding || "50px 0 40px 0"};
  text-align: center;

  > h1 {
    font-family: "Oswald", sans-serif;
    font-size: 40px;
    font-weight: var(--bold);
    letter-spacing: 2px;
    margin-top: 20px;
  }
`
export const SectionHeader = ({ title, padding }) => {
  return (
    <Header
      padding={padding}
      data-sal="slide-up"
      data-sal-delay="250"
      data-sal-easing="ease"
    >
      <StaticImage
        src="../../../images/header-up.png"
        alt="Section Header Uppper Icon"
        height={20}
      />
      <h1> {title}</h1>
    </Header>
  )
}
